function initializeCountdowns() {
	const potentialModules = document.querySelectorAll('[id^="m-"]');

	potentialModules.forEach((countdownModule) => {
		if (!countdownModule) return;

		const moduleElement = countdownModule.querySelector(".module");
		if (!moduleElement) return;

		const isAlreadyInitialized =
			moduleElement.getAttribute("data-initialized") === "true";
		if (isAlreadyInitialized) return;

		const hasCountdownAttributes =
			moduleElement.dataset.end ||
			moduleElement.dataset.type ||
			moduleElement.dataset.daily;

		if (!hasCountdownAttributes) return;

		const data = {
			end: moduleElement.dataset.end,
			type: moduleElement.dataset.type,
			daily: moduleElement.dataset.daily,
			evergreen: moduleElement.dataset.evergreen,
			redirect: moduleElement.dataset.redirect,
			cookietime: moduleElement.dataset.cookietime,
			evergreenloop: moduleElement.dataset.evergreenloop,
			timezone: moduleElement.dataset.timezone,
			autohide: moduleElement.dataset.autoHide,
		};

		// function initWithJQuery(jQuery) {
		// 	const $module = jQuery(`#${countdownModule.id}`).children(
		// 		".module"
		// 	);
		// 	if (typeof $module.gfV1Countdown === "function") {
		// 		$module.gfV1Countdown({
		// 			id: countdownModule.id.replace("m-", ""),
		// 			idSlug: countdownModule.id.replace("m-", ""),
		// 			...data,
		// 		});
		// 		moduleElement.setAttribute("data-initialized", "true");
		// 		return true;
		// 	}
		// 	return false;
		// }
		function initWithJQuery(jQuery) {
			const $module = jQuery(`#${countdownModule.id}`).children(
				".module"
			);
			if (moduleElement.getAttribute("data-initialized") === "true")
				return true;

			if (typeof $module.gfV1Countdown === "function") {
				moduleElement.setAttribute("data-initialized", "true"); // pre-mark
				try {
					$module.gfV1Countdown({
						id: countdownModule.id.replace("m-", ""),
						idSlug: countdownModule.id.replace("m-", ""),
						...data,
					});
				} catch (e) {
					moduleElement.removeAttribute("data-initialized"); // allow retry
					return false;
				}
				return true;
			}
			return false;
		}

		if (window.GemQuery && initWithJQuery(window.GemQuery)) return;
		if (window.jQuery && initWithJQuery(window.jQuery)) return;

		let attempts = 0;
		const maxAttempts = 80;
		const retryInterval = setInterval(() => {
			attempts++;
			if (
				(window.GemQuery && initWithJQuery(window.GemQuery)) ||
				(window.jQuery && initWithJQuery(window.jQuery)) ||
				attempts >= maxAttempts ||
				moduleElement.getAttribute("data-initialized") === "true"
			) {
				clearInterval(retryInterval);
			}
		}, 100);
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initializeCountdowns);
} else {
	initializeCountdowns();
}

window.addEventListener("load", initializeCountdowns);

let reinitScheduled = false;
const scheduleReinit = () => {
	if (reinitScheduled) return;
	reinitScheduled = true;
	requestAnimationFrame(() => {
		reinitScheduled = false;
		initializeCountdowns();
	});
};

const observer = new MutationObserver((mutations) => {
	for (const m of mutations) {
		for (const n of m.addedNodes) {
			if (!(n instanceof HTMLElement)) continue;
			if (
				n.matches?.(
					'[id^="m-"] .module[data-end], [id^="m-"] .module[data-daily], [id^="m-"] .module[data-type]'
				) ||
				n.querySelector?.(
					'[id^="m-"] .module[data-end], .module[data-daily], .module[data-type]'
				)
			) {
				scheduleReinit();
				return;
			}
		}
	}
});
observer.observe(document.documentElement, { childList: true, subtree: true });
